import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserPlus, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function AdminUsers({ users, newUser, setNewUser, handleCreateUser, handleDeleteUser, toggleUserActive }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="users-tab">
      <Card className="border-0 shadow-lg">
        <CardHeader><CardTitle>Nouvel Utilisateur</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={handleCreateUser} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><Label>Prénom</Label><Input value={newUser.first_name} onChange={(e) => setNewUser({...newUser, first_name: e.target.value})} required /></div>
              <div><Label>Nom</Label><Input value={newUser.last_name} onChange={(e) => setNewUser({...newUser, last_name: e.target.value})} required /></div>
            </div>
            <div><Label>Email</Label><Input type="email" value={newUser.email} onChange={(e) => setNewUser({...newUser, email: e.target.value})} required /></div>
            <div><Label>Mot de passe</Label><Input type="password" value={newUser.password} onChange={(e) => setNewUser({...newUser, password: e.target.value})} required /></div>
            <div><Label>Téléphone</Label><Input type="tel" value={newUser.phone} onChange={(e) => setNewUser({...newUser, phone: e.target.value})} /></div>
            <div>
              <Label>Rôle</Label>
              <select value={newUser.role} onChange={(e) => setNewUser({...newUser, role: e.target.value})} className="w-full border border-zinc-200 rounded-lg p-2">
                <option value="adherent">Adhérent</option>
                <option value="collaborateur">Collaborateur</option>
                <option value="admin">Administrateur</option>
              </select>
            </div>
            <Button type="submit" className="w-full bg-fuchsia-600 hover:bg-fuchsia-700"><UserPlus className="h-4 w-4 mr-2" />Créer l'utilisateur</Button>
          </form>
        </CardContent>
      </Card>
      <Card className="border-0 shadow-lg lg:col-span-2">
        <CardHeader><CardTitle>Liste des Utilisateurs ({users.length})</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-3">
            {users.map((u) => (
              <div key={u.id} className={`flex items-center justify-between p-4 rounded-lg ${u.is_active ? 'bg-zinc-50' : 'bg-red-50'}`}>
                <div>
                  <p className="font-medium text-zinc-900">{u.first_name} {u.last_name}</p>
                  <p className="text-sm text-zinc-500">{u.email}</p>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${u.role === 'admin' ? 'bg-fuchsia-100 text-fuchsia-700' : u.role === 'collaborateur' ? 'bg-lime-100 text-lime-700' : 'bg-blue-100 text-blue-700'}`}>{u.role}</span>
                </div>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" onClick={() => toggleUserActive(u.id, u.is_active)} className={u.is_active ? 'text-amber-600' : 'text-green-600'}>{u.is_active ? 'Désactiver' : 'Activer'}</Button>
                  <Button variant="outline" size="sm" onClick={() => handleDeleteUser(u.id)} className="text-red-600 hover:text-red-700"><Trash2 className="h-4 w-4" /></Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
